import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ppl-box-container-with-header',
    templateUrl: './box-container-with-header.component.html',
    styleUrls: ['./box-container-with-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BoxContainerWithHeaderComponent implements OnInit {

  @Input() title: string;
  @Input() titleUnderlined = true;

  constructor() { }

  ngOnInit() {
  }

}
